import { Instance, types } from "mobx-state-tree";
import { formatNumberBasedOnLanguage } from "../../helpers/MathHelpers";

import { DetailType } from "../../pages/settings/project-details/components/DetailType";
import {
  CustomProjectPropertyOption,
  CustomProjectPropertyOptionModel,
} from "./CustomProjectPropertyOption";

export const CustomPropertyModel = types
  .model({
    label: types.string,
    type: types.number,
    value: types.frozen(),
    columnId: types.number,
    index: types.number,
    options: types.optional(types.array(CustomProjectPropertyOptionModel), []),
  })
  .actions((self) => {
    const createOptions = (option: CustomProjectPropertyOption) => {
      return CustomProjectPropertyOptionModel.create({
        id: option.id,
        name: option.name,
        position: option.position,
        label: option.label,
        value: option.value,
      });
    };
    return {
      getSortedOptions(options: CustomProjectPropertyOption[]) {
        return options.sort((option1: any, option2: any) => option1.position - option2.position);
      },
      mapOptions(options: CustomProjectPropertyOption[]) {
        options.forEach((option: CustomProjectPropertyOption) => {
          const optionProperty = createOptions(option);
          self.options.push(optionProperty);
        });
      },
      isOfTypeText() {
        return self.type === Number(DetailType.Text);
      },
      isOfTypeNumber() {
        return self.type === Number(DetailType.Number);
      },
      isOfTypeDropdown() {
        return self.type === Number(DetailType.Dropdown);
      },
      isOfTypeDate() {
        return self.type === Number(DetailType.Date);
      },
      isOfTypeTime() {
        return self.type === Number(DetailType.Time);
      },
      formatNumber(value: any) {
        return formatNumberBasedOnLanguage(value);
      },
    };
  });
export type CustomProperty = Instance<typeof CustomPropertyModel>;
